<template>
  <div>
    <span v-if="config.text" class="mr1">{{ config.text }}</span>
    <a-input-number
      :value="field.value"
      :min="min"
      :max="config.max || 999999999"
      :step="config.step || 1"
      :disabled="disabled"
      :placeholder="config.placeholder || `请输入${config.label}`"
      :formatter="formatter"
      :parser="parser"
      @change="handleChange"
    />
  </div>
</template>
<script>
import { defineComponent, ref } from 'vue';
import { props } from './helper';

export default defineComponent({
  props: {
    ...props,
  },
  setup(props) {
    let min = ref(1);
    min = props.config.min === 0 ? 0 : props.config.min || 1;

    const keepOriginal = value => value;

    const formatter = props.config.formatter || keepOriginal;
    const parser = props.config.parser || keepOriginal;
    return {
      min,
      formatter,
      parser,
    };
  },
});
</script>
<style lang="less" scoped>
.ant-input-number {
  width: 100%;
}
</style>
